<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col v-if="notFound" xl="12" lg="12" sm="12" class="text-danger mb-2">
                            <div class="bg-gray pt-2 pb-2 pl-3">
                                <span>{{ (currentLocale === 'bn') ? 'শিশুর তথ্য পাওয়া যায়নি । দয়া করে আবার অনুসন্ধান করুন ভেলিড “শিশু নম্বর” ব্যবহার করে!' : 'Child data not found. Please search again using valid "Child Number"!' }}</span>
                            </div>
                        </b-col>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset">
                                    <b-list-group>
                                        <b-list-group-item class="d-flex align-items-center">
                                            <b-row>
                                                <b-col v-if="!id" sm="12" style="max-width: 80.333333% !important">
                                                    <ValidationProvider name="Child Number" vid="child_number" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="child_number"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('legal_institute_management.child_number')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        id="child_number"
                                                        v-model="search.child_number"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col v-if="!id">
                                                    <div class="text-right mb-2">
                                                        <b-button type="button" @click="loadChildData()" variant="success">{{ $t('globalTrans.search')}}</b-button>
                                                    </div>
                                                </b-col>
                                                <b-col xl="12" lg="12" sm="12">
                                                    <b-overlay class="row" :show="unitLoad">
                                                        <b-col v-if="id" xl="12" lg="12" sm="12">
                                                            <ValidationProvider name="Child Number" vid="child_number" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="child_number"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('legal_institute_management.child_number')}}
                                                                </template>
                                                                    <b-form-input
                                                                    id="child_number"
                                                                    v-model="courtData.child_number"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    disabled
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col xl="12" lg="12" sm="12">
                                                            <ValidationProvider name="Organization Name" vid="org_name" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="org_name"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('globalTrans.organization')}}
                                                                </template>
                                                                    <b-form-input
                                                                    id="org_name"
                                                                    v-model="courtData.org_name"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    disabled
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col xl="12" lg="12" sm="12">
                                                            <ValidationProvider name="Institute Type" vid="institute_type" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="institute_type"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('child_configuration.institute_type')}}
                                                                </template>
                                                                    <b-form-input
                                                                    id="child_name"
                                                                    v-model="courtData.institute_type"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    disabled
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col xl="12" lg="12" sm="12">
                                                            <ValidationProvider name="Institute Name" vid="institute_name" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="institute_name"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('child_configuration.institute_name')}}
                                                                </template>
                                                                    <b-form-input
                                                                    id="institute_name"
                                                                    v-model="courtData.institute_name"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    disabled
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col xl="12" lg="12" sm="12">
                                                            <ValidationProvider name="Child Name" vid="child_name" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="child_name"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('legal_institute_management.name_of_child')}}
                                                                </template>
                                                                    <b-form-input
                                                                    id="child_name"
                                                                    v-model="courtData.child_name"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    disabled
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col xl="12" lg="12" sm="12">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="4"
                                                                label-for="contact_no"
                                                            >
                                                            <template v-slot:label>
                                                            {{$t('legal_institute_management.contact_number')}}
                                                            </template>
                                                                <b-form-input
                                                                id="contact_no"
                                                                v-model="courtData.contact_no"
                                                                disabled
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col xl="12" lg="12" sm="12">
                                                            <ValidationProvider name="Case File Description" vid="case_description" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="case_description"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                <template v-slot:label>
                                                                    {{$t('legal_institute_management.case_file_description')}}
                                                                </template>
                                                                    <b-form-textarea
                                                                        id="case_description"
                                                                        v-model="courtData.case_description"
                                                                        disabled
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                        rows="2"
                                                                        max-rows="6"
                                                                    ></b-form-textarea>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-overlay>
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </b-list-group>
                                    <br>
                                     <b-row>
                                         <b-col sm="12" style="max-width: 70% !important">
                                            <ValidationProvider name="Court Date" vid="court_date">
                                                <b-form-group
                                                    class="row text-center"
                                                    label-cols-sm="6"
                                                    label-for="court_date"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('legal_institute_management.date')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input class="form-control"
                                                        v-model="dateObj.court_date"
                                                        placeholder="Select Date"
                                                        id="date"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback d-block">
                                                        {{ errorMsg }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col>
                                            <div class="text-right mb-2">
                                                <b-button type="button" @click="addItem()" variant="success">{{ $t('globalTrans.add')}}</b-button>
                                            </div>
                                        </b-col>
                                        <b-col xl="12" lg="12" sm="12">
                                            <b-table-simple bordered>
                                                <thead class="text-white" style="background-color: #577399">
                                                    <tr>
                                                        <th class="text-center mytd" width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                        <th class="mytd" scope="col">{{ $t('legal_institute_management.date') }}</th>
                                                        <th class="text-center mytd">{{ $t('globalTrans.action') }}</th>
                                                    </tr>
                                                </thead>
                                                <b-tbody>
                                                    <b-tr v-for="(item, index) in courtData.list" :key="index">
                                                        <b-td class="text-center mytd">{{ $n(index + 1) }}</b-td>
                                                        <b-td class="mytd">
                                                            <ValidationProvider name="Court Date" vid="court_date" rules="required">
                                                                <b-form-group
                                                                    slot-scope="{ valid, errors }"
                                                                    style="margin-bottom: 0rem"
                                                                >
                                                                    <b-form-input
                                                                        type="date"
                                                                        v-model="item.court_date"
                                                                        placeholder="Select Date"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-td>
                                                        <b-td class="text-center mytd">
                                                            <b-button type="button" @click="deleteItem(index)" class="btn btn-danger" size="sm"><i class="fa fa-trash"></i></b-button>
                                                        </b-td>
                                                    </b-tr>
                                                    <b-tr v-if="nodata">
                                                        <td colspan="4" class="text-center">
                                                            <span class="text-black">{{ (currentLocale === 'bn') ? 'কোন তথ্য পাওয়া যায়নি!' : 'No Data Found' }}</span>
                                                        </td>
                                                    </b-tr>
                                                </b-tbody>
                                            </b-table-simple>
                                        </b-col>
                                    </b-row>
                                    <div class="row mt-2">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { courtCalenderStoreApi, courtCalenderUpdateApi, childDataForCourtApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import { isNotEmpty } from '@amcharts/amcharts4/.internal/core/utils/Utils'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            nodata: true,
            notFound: false,
            unitLoad: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            search: {
                child_number: '',
                child_for: 'court_calender'
            },
            courtData: {
                id: 0,
                org_name: '',
                institute_type: '',
                institute_name: '',
                child_name: '',
                contact_no: '',
                case_description: '',
                list: []
            },
            dateObj: {
                court_date: ''
            },
            errorMsg: ''
        }
    },
    created () {
        if (this.id) {
            const tmp = this.getCalendar()
            this.courtData.id = tmp.id
            this.courtData.child_number = tmp.case_file.child_info.child_number
            this.courtData.org_name = this.getOrgName(tmp.case_file.child_info.org_id)
            this.courtData.institute_type = this.getInstituteType(tmp.case_file.child_info.office_type_id)
            this.courtData.institute_name = this.$i18n.locale === 'bn' ? tmp.case_file.child_info.name_bn : tmp.case_file.child_info.name
            this.courtData.child_name = this.$i18n.locale === 'bn' ? tmp.case_file.child_info.name_bn : tmp.case_file.child_info.name
            this.courtData.contact_no = tmp.case_file.child_info.mobile_no
            this.courtData.case_description = this.$i18n.locale === 'bn' ? tmp.case_file.file_description_bn : tmp.case_file.file_description
            this.courtData.list = tmp.list
            this.nodata = false
        }
    },
    mounted () {
        flatpickr('#date', {})
        core.index()
    },
    computed: {
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
        'search.child_number': function (newVal, oldVal) {
            this.notFound = false
            this.courtData = {}
        },
        'dateObj.court_date': function (newVal, oldVal) {
            this.errorMsg = ''
        }
    },
    methods: {
        loadChildData () {
            this.unitLoad = true
            RestApi.getData(childServiceBaseUrl, childDataForCourtApi, this.search).then(response => {
                if (response.success) {
                    if (isNotEmpty(response.data)) {
                        this.courtData.id = response.data.id
                        this.courtData.org_name = this.getOrgName(response.data.org_id)
                        this.courtData.institute_type = this.getInstituteType(response.data.office_type_id)
                        this.courtData.institute_name = this.getInstituteName(response.data.office_id)
                        this.courtData.child_name = this.$i18n.locale === 'bn' ? response.data.name_bn : response.data.name
                        this.courtData.contact_no = response.data.mobile_no
                        this.courtData.case_description = this.$i18n.locale === 'bn' ? response.data.file_description_bn : response.data.file_description
                        this.courtData.list = []
                        this.notFound = false
                    } else {
                        this.notFound = true
                    }
                    this.unitLoad = false
                }
            })
        },
        deleteItem (index) {
            this.courtData.list.splice(index, 1)
            if (!isNotEmpty(this.courtData.list)) {
                this.nodata = true
            }
        },
        addItem () {
            if (this.dateObj.court_date !== '') {
                const courtDate = this.dateObj.court_date
                const newData = this.courtData.list.find(item => item.court_date === courtDate)
                if (typeof newData === 'undefined') {
                    this.courtData.list.push(JSON.parse(JSON.stringify(this.dateObj)))
                    this.dateObj.court_date = ''
                } else {
                    newData.court_date = this.dateObj.court_date
                    this.dateObj.court_date = ''
                    // this.errorMsg = 'Court date already exists in the list'
                }
                this.nodata = false
            } else {
                this.errorMsg = 'Invalid court date'
            }
        },
        getOrgName (orgId) {
            const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteName (Id) {
            const tmpData = this.$store.state.commonObj.officeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getCalendar () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async storeUpdate () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            if (this.nodata === false) {
                let result = null
                const loadinState = { loading: false, listReload: true }
                if (this.id) {
                    result = await RestApi.putData(childServiceBaseUrl, `${courtCalenderUpdateApi}/${this.id}`, this.courtData)
                } else {
                    result = await RestApi.postData(childServiceBaseUrl, courtCalenderStoreApi, this.courtData)
                }
                this.$store.dispatch('mutateCommonProperties', loadinState)
                if (result.success) {
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.$toast.error({
                        title: this.$t('globalTrans.error'),
                        message: result.message,
                        color: '#D6E09B'
                    })
                    this.$refs.form.setErrors(result.errors)
                }
            } else {
                this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: this.$i18n.locale === 'bn' ? 'কোর্ট তারিখ আবশ্যক' : 'Court date required'
                })
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            }
        }
    }
}

</script>
<style scoped>
    .mytd{
        padding: 0.25rem 0.75rem 0.25rem 0.75rem !important;
    }
</style>
